import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'Zatca';

  constructor() {
    const _TranslateService = inject(TranslateService);

    // this language will be used as a fallback when a translation isn't found in the current language
    _TranslateService.setFallbackLang('ar');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    _TranslateService.use('ar');
  }
}
